import React, {
  Dispatch,
  FC,
  Key,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import {
  Button,
  Form,
  Table,
  TableColumnsType,
  Tooltip,
  Typography,
} from "antd";
import type { ColumnGroupType, ColumnType, TableProps } from "antd/es/table";
import {
  GetOrderDetailData,
  GetTransportShipedOrderdata,
  GetTransportShipedResponseData,
  GetTransportShippedDetailData,
} from "services/interface";
import { formatDate, formatDateWithTime } from "utils/dateFormat";

import ModalOderDetail from "./ModalOrderDetail";
// import { useGetOrderDetail } from "hooks/useOrders";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setLoading } from "store/slices/loadingSlice";

import ExportToExcel from "./ExportToExcel";
import { useGetTransportShippedDetail } from "hooks/useShipping";
import {
  setDataTransportShippedLimit,
  setDataTransportShippedOffset,
} from "store/slices/orderSlice";
import { CreditCardOutlined, PrinterOutlined } from "@ant-design/icons";
import ModalBoxCount from "../ShippingPrepare/ModalBoxCount";
import { useGetOrderDetail } from "hooks/useOrders";

type TableRowSelection<T> = TableProps<T>["rowSelection"];

interface OrderTableListProps {
  data?: GetTransportShipedResponseData;
  IsHiddenPersonInfo?: boolean;
  refetchData: () => void;
  childrenBank: React.ReactNode[];
  refetchPrepare?: () => void;
}

const OrderTableList: FC<OrderTableListProps> = ({
  data,
  IsHiddenPersonInfo,
  refetchData,
  childrenBank,
  refetchPrepare,
}) => {
  const [form] = Form.useForm();
  const [modalVisibility, setModalVisibility] = useState<{
    [key: string]: boolean;
  }>({});

  const dispatch = useAppDispatch();
  const offset = useAppSelector(
    (state) => state.order.dataTransportShipped.offset
  );
  const limit = useAppSelector(
    (state) => state.order.dataTransportShipped.limit
  );

  const [refId, setRefId] = useState<string>("");
  const [showEdit, setShowEdit] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [isModalLabel, setisModalLabel] = useState(false);
  const [orderId, setOrderId] = useState<string>("");

  const [currentPage, setCurrentPage] = useState(1);

  const { mutateAsync: oderDetailMutate } = useGetOrderDetail();

  useEffect(() => {
    setCurrentPage(Math.floor(offset / limit) + 1);
  }, [offset, limit]);

  const showEditModal = (order_id: string, ref_id: string) => {
    setShowEdit(true);
    setRefId(ref_id);
    console.log(order_id);
  };

  const [modalData, setModalData] = useState<GetTransportShippedDetailData>();

  const [oderDetail, setOderDetail] = useState<GetOrderDetailData>();

  const { mutateAsync } = useGetTransportShippedDetail();

  const [isProductProblem, setIsProductProblem] = useState<boolean>(false);

  const showDrawer = (order_id: string) => {
    setModalVisibility((prev) => ({
      ...prev,
      [order_id]: true,
    }));
  };

  const showPrintLabel = () => {
    setisModalLabel(true);
  };

  const columns: TableColumnsType<GetTransportShipedOrderdata> = [
    {
      title: "Order No.",
      dataIndex: "order_code",
      key: "order_id",
      width: "200px",
      fixed: "left",
      render: (_text, record) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
            type="secondary"
            onClick={async () => {
              dispatch(setLoading(true));

              await mutateAsync(
                {
                  order_id: record.order_id,
                  status: "wait_agent_confirm",
                },
                {
                  onSuccess: async (data) => {
                    setModalData(data.data[0]);

                    // setIsProductProblem(record.is_problem);

                    await new Promise((resolve) => setTimeout(resolve, 200));

                  
                  },
                  onError: (error: any) => {
                    console.log(error);
                    dispatch(setLoading(false));
                  },
                }
              );

              await oderDetailMutate(
                {
                  key_type: "order_id",
                  group_by: "factory",
                  items: [record.order_id],
                },
                {
                  onSuccess: (data) => {
                    setOderDetail(data.data[0]);
                  },
                  onError: (error) => {
                    console.log(error);
                    dispatch(setLoading(false));
                  },
                }
              );

              dispatch(setLoading(false));

              setShowDetail(true);

            }}
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      title: "วันที่สั่งซื้อ",
      dataIndex: "order_date",
      width: "100px",
      render: (_text) => {
        return <Typography.Text>{formatDateWithTime(_text)}</Typography.Text>;
      },
    },
    {
      title: "วันที่จัดส่ง",
      dataIndex: "due_date",
      width: 200,
      render: (_text) => <Typography.Text>{formatDate(_text)}</Typography.Text>,
    },
    {
      title: "ประเภทการจัดส่ง",
      dataIndex: "transport_type_name",
      key: "transport_type_name",
      width: "200px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    // {
    //   title: "สถานี",
    //   dataIndex: "station_ship",
    //   key: "station_ship",
    //   width: "200px",

    //   render: (_text) => {
    //     return <Typography.Text>{_text}</Typography.Text>;
    //   },
    // },
    // {
    //   title: "ขนส่ง",
    //   dataIndex: "bus_name",
    //   key: "bus_name",
    //   width: "200px",

    //   render: (_text) => {
    //     return <Typography.Text>{_text}</Typography.Text>;
    //   },
    // },
    {
      title: "บริษัท",
      dataIndex: "brand_name",
      key: "brand_name",
      width: "200px",

      render: (_text, record) => {
        return <Typography.Text>{
            record?.transport_type === "post_office" ? _text : record?.bus_name
          }</Typography.Text>;
      },
    },
    {
      title: "เลข Tracking",
      dataIndex: "postal_code",
      key: "postal_code",
      width: "200px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "ชื่อผู้รับสินค้า",
      dataIndex: "address_name",
      key: "address_name",
      width: "200px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "address_telephone",
      key: "address_telephone",
      width: "130px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "จังหวัด",
      dataIndex: "province_name",
      key: "province_name",
      width: "150px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "อำเภอ",
      dataIndex: "district_name",
      key: "district_name",
      width: "150px",

      render: (_text) => {
        return <Typography.Text>{_text}</Typography.Text>;
      },
    },
    {
      title: "พิมพ์",
      align: "center",
      fixed: "right",
      render: (_text, record) => (
        <div style={{ display: "flex", flexDirection: "row", gap: 4 }}>
          <Tooltip title="พิมพ์ใบส่งของ">
            <Button
              size="small"
              type="default"
              onClick={() => {
                window.open(`/print-deliverynote/${record?.order_id}`);
              }}
            >
              <PrinterOutlined />
            </Button>
          </Tooltip>
          <Tooltip title="พิมพ์ Label">
            <Button
              size="small"
              type="default"
              onClick={() => {
                showPrintLabel();
                setOrderId(record?.order_id);
              }}
            >
              <CreditCardOutlined />
            </Button>
          </Tooltip>
        </div>
      ),
    },
    // {
    //   title: "ที่อยู่",
    //   dataIndex: "address_text",
    //   key: "address_text",
    //   width: 60,
    //   render: (_text) => {
    //     return <Typography.Text>{_text}</Typography.Text>;
    //   },
    // },
  ];

  let filtersColumns: (
    | ColumnGroupType<GetTransportShipedOrderdata>
    | ColumnType<GetTransportShipedOrderdata>
  )[] = columns;
  if (IsHiddenPersonInfo) {
    filtersColumns = columns.filter(
      (column) => column.key !== "ref_name" && column.key !== "ref_telephone"
    );
  }

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const rowSelection: TableRowSelection<GetTransportShipedOrderdata> = {
    selectedRowKeys,
    onSelect: (record, selected, newSelectedRows) => {
      if (selected) {
        setSelectedRowKeys((prevKeys) => [...prevKeys, record.order_id]);
      } else {
        setSelectedRowKeys((prevKeys) =>
          prevKeys.filter((key) => key !== record.order_id)
        );
      }
    },
  };
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          marginBottom: 16,
        }}
      >
        <div style={{ flex: 1 }}></div>
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
          {/* <Button
            type="default"
            style={{ marginRight: 10 }}
            // icon={<DownloadOutlined />}
            size="middle"
            // loading={loading}
            // onClick={exportToExcel}
          >
            Export Tax
          </Button> */}
          <ExportToExcel />
        </div>
      </div>
      <Table
        rowKey="order_id"
        size="small"
        columns={filtersColumns}
        scroll={{ y: 600, x: true }}
        dataSource={data?.order_data}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: parseInt(data?.total_record as string),
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            dispatch(setDataTransportShippedOffset(pageSize! * (page! - 1)));
            dispatch(setDataTransportShippedLimit(pageSize!));
          },
        }}
        // rowSelection={rowSelection}
      />
      <ModalOderDetail
        open={showDetail}
        onClose={() => {
          setShowDetail(false);
        }}
        item={modalData as GetTransportShippedDetailData}
        childrenBank={childrenBank}
        refetchData={refetchData}
        statusPage="new_order"
        showEditModal={showEditModal}
        isProductProblem={isProductProblem}
        oderDetail={oderDetail}
      />
      <ModalBoxCount
        isModalLabel={isModalLabel}
        setisModalLabel={setisModalLabel}
        orderId={orderId}
      />
    </div>
  );
};

export default OrderTableList;
